module.exports = __webpack_public_path__ + "media/images/brussels/confirmation/confirmation-image-2-0e62efd15c4c2c26838a06c44721535f.png";